import React from 'react';
import Navbar from '../../components/navbar';
import FooterAppp from '../../components/footerApp';
import FrequenceQuestionsComponent from './faqs';
const FrequenceQuestions = () => {
  return (
    <React.Fragment>
      <Navbar isBlack={true} />
      <FrequenceQuestionsComponent />
      <FooterAppp />
    </React.Fragment>
  );
};

export default FrequenceQuestions;
